module.exports = __webpack_public_path__ + "img/order return.72448ced.svg";